import { useEffect, useState } from "react";
import { Calendar } from "lucide-react";
import { fetchSancharaStops } from "@/api/events";
import { useLang } from "@/i18n";
import PageHeader from "@/components/PageHeader";

export default function Sanchara() {
  const [stops, setStops] = useState([]);
  const { t, lv, fmtDate } = useLang();
  useEffect(() => { fetchSancharaStops().then(setStops).catch(() => {}); }, []);

  return (
    <div data-testid="sanchara-page">
      <PageHeader eyebrow={t.sanchara.eyebrow} title={t.sanchara.title} sub={t.sanchara.sub} />

      <section className="section-pad">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative">
            <div className="absolute left-6 top-2 bottom-2 w-px bg-gradient-to-b from-transparent via-[#D4AF37] to-transparent" />

            <div className="space-y-10">
              {stops.map((s, i) => (
                <div key={s.id} data-testid={`sanchara-item-${i}`} className="reveal relative pl-16">
                  <div className="absolute left-6 -translate-x-1/2 top-6 w-4 h-4 rounded-full bg-[#D4AF37] ring-4 ring-[#FDFBF7]" />
                  <div className="card-soft p-6 md:p-7 flex flex-col md:flex-row gap-6 items-start">
                    {s.image && (
                      <div className="w-full md:w-56 aspect-[4/3] rounded-xl overflow-hidden shrink-0">
                        <img src={s.image} alt={lv(s, "location")} className="w-full h-full object-cover" />
                      </div>
                    )}
                    <div className="flex-1">
                      <div className="eyebrow flex items-center gap-2"><Calendar size={12} /> {fmtDate(s.date)}</div>
                      <h3 className="mt-2 font-display text-2xl text-[#2A2118] leading-snug">{lv(s, "location")}</h3>
                      <p className="mt-3 text-[15px] text-[#5C4D42] leading-relaxed">{lv(s, "description")}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {stops.length === 0 && (
            <div className="text-center text-[#5C4D42] py-16">{t.sanchara.empty}</div>
          )}
        </div>
      </section>
    </div>
  );
}
